<div class="d-flex min-vh-75 w-100 flex-column justify-content-center">
    <div class="">                    
        
        
    </div>
    <div class="flex-grow-1 "></div>
    <div class="d-flex d-flex justify-content-center">

        <div class="assessment-block">

            <h4 class="mb-4">Welcome to your complimentary self-assessment!</h4>
            
            <p>
                Taking a moment to assess your diabetes management is a powerful 
                step toward a healthier you. This brief questionnaire is designed 
                to provide you with valuable insights into your current health status. 
                Don't worry; it won't take long – just a few minutes of your time.
            </p>
            <p>            
                <span class="fw-bold">Your responses are entirely confidential and anonymous.                
                Your comfort and privacy are our top priorities.</span>
            </p>
            <p>
                Let's get started on this quick journey to enhance your diabetes care. 
                Your health matters, and this assessment is tailored to make it easy 
                and informative for you. Thank you for taking the time for your well-being!
            </p>

            <button (click)="_startNewAssessment()" class="btn btn btn-primary mt-2 me-1 mb-1" type="button">Start Self-Assessment</button>
            
            <!--
            <p><b>What's Next?</b></p>

            <p>
                Now our platform learned a bit about you and created your very own personal 
                experience with an individual care plan for your diabetes journey.<br>
                Please click on a “My Personal Dashboard” button below to start. And remember, 
                it does not stop here – you can always customize your dashboard 
                and fine tune your daily routine anytime to keep it up to date with 
                your life and health!
            </p>

            <p>
                <b>We are so happy to have you in our platform!</b>
            </p>
            -->
            

        </div>
    </div>
    <div class="p-2 flex-grow-1"></div>
    
    <div class="d-flex mb-2">
        <!--
        <div class="me-auto p-2">
            <button class="btn btn-link" (click)="_prevButton()" type="submit">Prev</button>
        </div>
        <div class="p-2">
            <button class="btn btn-link" type="submit">Skip</button>
        </div>-->
       
    </div>
</div>
